import { PenIcon } from "@xola/icons";
import { FormGroup, Label } from "@xola/ui-kit";
import clsx from "clsx";
import { FormField, SwitchField } from "common";
import { useField } from "formik";
import React, { useState } from "react";
import { AllowedPrivacy, ProductObject, SelectionState } from "types";
import { ProductSelectorModal } from "@/components/Common/ProductSelectorModal";
import { SecondaryButton } from "@/components/Common/SecondaryButton";
import { SelectedProductList } from "@/components/Common/SelectedProductList";

export const MembershipProductRestriction = () => {
    const [{ value }, { touched }, { setValue }] = useField<SelectionState>("experiences");
    const [productSelectorModalOpen, setProductSelectorModalOpen] = useState(false);
    const hasSelectedExperiences = value.all || value.selected.length > 0;

    const hasError = touched && !hasSelectedExperiences;

    return (
        <FormGroup className="space-y-2">
            <div className="flex items-end">
                <Label className={clsx("flex-grow", hasError && "!text-danger")}>
                    Products {hasError && "- Select one or more experiences"}
                </Label>
                <SecondaryButton size="small" onClick={() => setProductSelectorModalOpen(true)}>
                    <PenIcon />
                </SecondaryButton>
            </div>
            <ProductSelectorModal
                isOpen={productSelectorModalOpen}
                value={value}
                objects={[ProductObject.EXPERIENCE]}
                onClose={() => setProductSelectorModalOpen(false)}
                onConfirm={setValue}
            />
            <SelectedProductList selectedProducts={value ?? { all: true, experiences: [] }} />
        </FormGroup>
    );
};

export const MembershipEventTypeRestriction = () => {
    const [{ value: allowedPrivacies }, , { setValue }] = useField<AllowedPrivacy[]>("allowedPrivacies");

    const options = [
        {
            value: AllowedPrivacy.PRIVATE,
            label: "Private Events",
        },
        {
            value: AllowedPrivacy.PUBLIC,
            label: "Public Events",
        },
    ];

    const handleToggle = (privacy: AllowedPrivacy) => (checked: boolean) => {
        if (checked) {
            setValue([...allowedPrivacies, privacy]);
            return;
        }

        setValue(allowedPrivacies.filter((item) => item !== privacy));
    };

    return (
        <FormField name="allowedPrivacies" label="Event Types">
            <div className="flex flex-col gap-y-2">
                {options.map((option) => (
                    <SwitchField
                        key={option.value}
                        isChecked={allowedPrivacies.includes(option.value)}
                        onChange={handleToggle(option.value)}
                    >
                        {option.label}
                    </SwitchField>
                ))}
            </div>
        </FormField>
    );
};
